import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getBillCreated,
  getCheckoutVisible,
  getCurrentRegion,
  getOrderNumber,
  getOrderNumberUuid,
  initCheckoutVisible,
  setCheckoutVisible,
} from "../../store/order";
import {ArrowPathIcon} from "@heroicons/react/24/outline";
import {receiveOrderByShopAndRegion} from "../../store/order/actions";
import ShopCartCheckoutForm from "./shopCartCheckoutForm";
import ShopCartCheckoutConsent from "./shopCartCheckoutConsent";
import AccountLinkBlock from "./accountLinkBlock";
import OrderStatusChecker from "./orderStatusChecker";
  
function ShopCartTotal({ cart, shop }) {
  const currentRegion = useSelector(getCurrentRegion(shop));
  const dispatch = useDispatch();
  const orderNumber = useSelector(getOrderNumber(shop));
  const orderNumberUuid = useSelector(getOrderNumberUuid(shop));
  // Глобальный флаг — не зависит от конкретного магазина
  const checkoutVisible = useSelector(getCheckoutVisible);
  const billCreated = useSelector(getBillCreated(shop));

  useEffect(() => {
    // Восстанавливаем глобальный checkoutVisible после refresh.
    // Состояние продолжает храниться в redux-store; sessionStorage используется только как persistence.
    dispatch(initCheckoutVisible(false));
  }, [dispatch, orderNumberUuid]);

  const clearOrder = () => {
    dispatch(
      receiveOrderByShopAndRegion(shop, {
        params: { regionType: currentRegion, createOrder: true },
      })
    );
  };
  return (
    <div className="shop-summary-card relative my-2 flex flex-col items-center">
      <ArrowPathIcon
        className=" absolute right-2 top-2 h-7 w-7 cursor-pointer rounded-full bg-blue-600 p-1 text-white shadow-md transition-all duration-300 hover:bg-blue-700 hover:scale-110"
        onClick={() => clearOrder()}
        title="Пересоздать заказ"
      />
      <div className=" mb-2 flex flex-col items-center justify-between gap-2">
        <div className=" flex flex-col items-center gap-0">
          <span className=" totalTitle">Заказ:</span>
          <span className=" totalTitle"># {orderNumber}</span>
          <span className=" totalText">{cart.caption}</span>
        </div>
        <div className=" flex flex-col items-center gap-0">
          <span className=" totalTitle">Сумма:</span>
          <span className=" totalText">{cart.originalSumText}</span>
        </div>
        <div className=" flex flex-col items-center gap-0">
          <div className="totalTitle flex items-center justify-center gap-1">
            <span>Персональная скидка</span>
            <AccountLinkBlock shop={shop} variant="discount" />
            <span>:</span>
          </div>
          <span className=" totalText">{cart.personalDiscount}</span>
        </div>
        <div className=" flex flex-col items-center gap-0">
          <span className=" totalTitle">Всего к оплате:</span>{" "}
          <span className=" totalText">{cart.finalSumText}</span>
        </div>
      </div>

      <ShopCartCheckoutForm cart={cart} shop={shop} isVisible={checkoutVisible} />

      <ShopCartCheckoutConsent
        isVisible={!checkoutVisible}
        onAccept={() => dispatch(setCheckoutVisible(true))}
      />

      {/* Проверка оплаты созданного счёта не зависит от согласия в текущей вкладке */}
      {billCreated && (
        <OrderStatusChecker
          orderNumberUuid={orderNumberUuid}
          userEmail={cart.userEmail}
          shopType={shop}
        />
      )}
    </div>
  );
}

export default ShopCartTotal;
